import React from 'react';
import PropTypes from 'prop-types';

import { AVATAR_MEDIUM } from '../../../utils/crops';

// import initialsString from '../../../utils/initialsString';

import {
  WrapperResultItem,
  WrapperHeader,
  WrapperImage,
  WrapperBody,
  ResultTitle,
  PersonParagraph,
  PersontAvatar,
  PersonSubtitle
} from './style';

const PersonItem = ({
  className,
  name,
  lastname,
  userId,
  subtitle,
  text,
  avatar,
  urlLink,
  onClick,
  avatarPhoto
}) => (
  <WrapperResultItem className={className} to={urlLink} onClick={onClick}>
    <WrapperImage imgAvatar={avatar} avatar>
      <PersontAvatar
        name={name}
        lastname={lastname}
        userId={userId}
        crop={AVATAR_MEDIUM}
        avatarPhoto={avatarPhoto}
      />
    </WrapperImage>
    <WrapperBody>
      <WrapperHeader>
        <div>
          <ResultTitle>{`${name} ${lastname}`}</ResultTitle>
          <PersonSubtitle>{subtitle}</PersonSubtitle>
        </div>
      </WrapperHeader>
      {text && <PersonParagraph maxlength={140} text={text} />}
    </WrapperBody>
  </WrapperResultItem>
);

PersonItem.propTypes = {
  className: PropTypes.string,
  urlLink: PropTypes.string,
  name: PropTypes.string,
  lastname: PropTypes.string,
  userId: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  avatar: PropTypes.string,
  onClick: PropTypes.func,
  avatarPhoto: PropTypes.bool
};

PersonItem.defaultProps = {
  urlLink: '/'
};

export default PersonItem;
